import find from 'lodash/find';
import size from 'lodash/size';

//This should be ported over to use selector model
//Receives entity object from state
export const hasEventResults = (results) => {
    const eventResults = find(results, ({ type }) => type === 'event') || {};

    return !!size(eventResults.content);
};
